import { useEffect, useState, useContext } from "react";
import "./Integration.css";
import {
  VYLABS_BASE_URL,
  TENANT_FIELD_DEFINITIONS_LIST,
  TENANT_FIELD_DEFINITIONS_CREATE,
  TENANT_FIELD_DEFINITIONS_UPDATE,
  TENANT_FIELD_DEFINITIONS_DELETE,
  TENANT_FIELD_DEFINITIONS_REORDER,
  JOBS_LIST,
  SEARC_JOBS,
  TENANTS_APPLICATION_STAGES_LIST,
  TENANTS_CREATE_APPLICATION_STAGE,
  TENANTS_UPDATE_APPLICATION_STAGE,
  TENANTS_REORDER_APPLICATION_STAGES,
} from "../../helper/url_helper";
import { get, post, deleteRequest } from "../../helper/Api_helper";
import { invalidateCallStagesCache } from "../../Common/DynamicCallStage/DynamicCallStageMapping";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import { useFormik } from "formik";
import Button from "../../Common/Button/Button";
import NojobsAnimation from "../../Assets/Json/nodata-found-robot-animation.json";
import AnimationPlayer from "../../Common/Animation-Player/AnimationPlayer";
import VybogTALLoaderAnimation from "../../Common/Dynamic-Animations/DynamicAnimations";
import {
  StandardPopup,
  ConfirmationPopup,
} from "../../Common/PopupStyles/PopupComponent";
import DynamicSelectInput from "../../Common/Select-Input/SelectInput";
import DynamicTextField from "../../Common/Textfield/Textfield";
import ToggleSwitcher from "../../Common/Toggle-Switcher/ToggleSwitcher";
import OptionsData from "../../Assets/Json/StaticOptions.json";
import { createPortal } from "react-dom";
import { filterPayload, toCapitalize } from "../../Common/Common-Function/CommonFunctions";
import CustomAutocomplete from "../../Common/AutoComplete/AutoComplete";
import {
  TENANT_CORE_API_KEY,
  TENANT_PRIME_API_KEY,
} from "../../Tenant-Config/TenantConfig";
import editIcon from "../../Assets/Images/cf-edit-icon-dark.svg";
import deleteIcon from "../../Assets/Images/cf-delete-icon-dark.svg";
import editLightIcon from "../../Assets/Images/cf-edit-icon-light.svg";
import deleteLightIcon from "../../Assets/Images/cf-delete-icon-light.svg";
import addIcon from "../../Assets/Images/create-icon.png";
import Table from "../../Common/Table/Table";
import dropdownIcon from "../../Assets/Images/cf-dropdown-icon-light.svg";
import dropdownDarkIcon from "../../Assets/Images/cf-dropdown-icon-dark.svg";
import { DynamicContext } from "../../Context/DynamicContext";
import SidePopup from "../../Common/SidePopup/SidePopup";
import cfSystemLock from "../../Assets/Images/cf-system-lock.svg";
import cfPreviewDelete from "../../Assets/Images/delete-red-icon.png";
import quickAddIcon from "../../Assets/Images/ai-job-desc-icon.svg";
import Accordion from "../../Common/Accordion/Accordion";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import saveIcon from "../../Assets/Images/save-icon.svg";
import HorizontalTabs from "../../Common/Horizontal-Tabs/HorizontalTabs";
import styled from "@emotion/styled";
import dragAndDropIcon from "../../Assets/Images/upload.svg";
import CustomTooltip from "../../Common/Tooltip/Tooltip";
import infoIcon from "../../Assets/Images/infoicon.svg";
import DynamicAutocomplete from "../../Common/AutoSuggestion/DynamicAutocomplete";
import MonthFilter from "../../Common/Month-Filter/MonthFilter";
import crownIcon from "../../Assets/Images/crown.png";

const JOBS_PAGE_SIZE = 10;
const getJobsPageFromOffset = (offsetValue = 0) =>
  Math.floor(Number(offsetValue || 0) / JOBS_PAGE_SIZE) + 1;

const { StaticOptions = {} } = OptionsData || {};
const {
  fieldTypes = [],
  candidateCreateFields = [],
  cfQuickAddFields = [],
  callStageFilters = [],
} = StaticOptions || {};

const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const FileInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FileInput = styled.input`
  display: none;
`;

const FileInputLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: var(--body__background);
  border: 2px dashed #6860ee;
  border-radius: 16px;
  font-size: 14px;
  color: #6860ee;
  width: 100%;
  text-align: center;
  height: 150px;
  justify-content: center;
  transition: background-color 0com;
}
`;

const FileName = styled.span`
  font-size: 14px;
  color: #6a69eb;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 600;
`;

const CalendarIntegration = () => {
  const { isDarkMode } = useContext(DynamicContext);
  const [fields, setFields] = useState([]);
  const [isCreateFieldPopupOpen, setIsCreateFieldPopupOpen] = useState(false);
  const [isUpdateFieldPopupOpen, setIsUpdateFieldPopupOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [stageCurrentPage, setStageCurrentPage] = useState(1);
  const [editingField, setEditingField] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [isTableEditClicked, setIsTableEditClicked] = useState(false);
  const [selectedQuickAddKey, setSelectedQuickAddKey] = useState(null);
  const [isReorderCfOn, setIsReorderCfOn] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [jobListOptions, setIsJobListOptions] = useState([]);
  const [jobOptionLoading, setIsJobOptionLoading] = useState(false);
  const [filterValue, setIsFilterValue] = useState({
    jobId: "",
    jobTitle: "",
    search: "",
  });
  const [stages, setStages] = useState([]);
  const [previewStages, setPreviewStages] = useState([]);
  const [stageLoading, setStageLoading] = useState(false);
  const [isUpdateStagePopupOpen, setIsUpdateStagePopupOpen] = useState(false);
  const [editingStage, setEditingStage] = useState(null);
  const [isDeleteStageOpen, setIsDeleteStageOpen] = useState(false);
  const [deleteStageId, setDeleteStageId] = useState(null);
  const [deleteStageActive, setDeleteStageActive] = useState(true);
  const [isReorderStagesOn, setIsReorderStagesOn] = useState(false);
  const [isActiveStageFilter, setIsActiveStageFilter] = useState(true);
  const [isActiveStageCategory, setIsActiveStageCategory] = useState(true);
  const [callStageFilter, setCallStageFilter] = useState("All Stages");
  const [systemCallStages, setSystemCallStages] = useState([]);
  const [customCallStages, setCustomCallStages] = useState([]);
  const [allCallStages, setAllCallStages] = useState([]);

  const initialStageValues = {
    id: "",
    name: "",
    category: "active",
    is_active: true,
    isActiveCategory: true,
  };

  const stageFormik = useFormik({
    initialValues: initialStageValues,
    enableReinitialize: true,
  });

  const initialFieldValues = {
    // entity_type: "",
    field_key: "",
    field_type: "",
    label: "",
    required: false,
    options: [],
    job_id: "",
    id: "",
  };

  const createFormik = useFormik({
    initialValues: initialFieldValues,
    enableReinitialize: true,
  });

  const editFormik = useFormik({
    initialValues: initialFieldValues,
    enableReinitialize: true,
  });
  const fetchStages = async (
    activeOnly = isActiveStageFilter,
    setStageList = setStages,
  ) => {
    setStageLoading(true);
    try {
      const endpoint =
        activeOnly === "all"
          ? TENANTS_APPLICATION_STAGES_LIST
          : `${TENANTS_APPLICATION_STAGES_LIST}?active=${activeOnly}`;

      const response = await get(
        VYLABS_BASE_URL,
        endpoint,
        { headers: { "X-API-Key": TENANT_CORE_API_KEY } },
      );
      const stageData = Array.isArray(response)
        ? response
        : response?.stages ||
        response?.application_stages ||
        response?.applicationStages ||
        [];
      const normalizedStages = Array.isArray(stageData) ? stageData : [];

      setStageList(normalizedStages);
      if (activeOnly === "all") {
        setAllCallStages(normalizedStages);
        setSystemCallStages(normalizedStages.filter((stage) => stage?.is_system));
        setCustomCallStages(normalizedStages.filter((stage) => !stage?.is_system));
      }

      return normalizedStages;
    } catch (error) {
      console.error("error in fetchStages:", error);
      Toast("error", error?.response?.data || "Failed to fetch call stages");
    } finally {
      setStageLoading(false);
    }
  };

  const getPreviewFetchType = () => {
    switch (callStageFilter) {
      case "Active":
        return true;
      case "Inactive":
        return false;
      case "System":
      case "Custom":
      case "All Stages":
      default:
        return "all";
    }
  };

  const refreshPreviewStages = async () => {
    const activeOnly = getPreviewFetchType();
    const stageData = await fetchStages(activeOnly, setPreviewStages);

    if (!stageData) return;

    if (callStageFilter === "System") {
      setPreviewStages(stageData.filter((stage) => stage?.is_system));
    } else if (callStageFilter === "Custom") {
      setPreviewStages(stageData.filter((stage) => !stage?.is_system));
    } else {
      setPreviewStages(stageData);
    }
  };

  const createStage = async () => {
    const name = stageFormik.values.name?.trim();
    const category = isActiveStageCategory ? "active" : "terminal";
    if (!name) {
      Toast("error", "Please fill all the required fields!");
      return;
    }
    try {
      const response = await post(
        VYLABS_BASE_URL,
        TENANTS_CREATE_APPLICATION_STAGE,
        { name, category },
        { headers: { "X-API-Key": TENANT_PRIME_API_KEY } },
      );
      if (response) {
        invalidateCallStagesCache();
        Toast("success", "Call Stage created successfully");
        stageFormik.resetForm();
        fetchStages(isActiveStageFilter, setStages);
        refreshPreviewStages();
      }
    } catch (error) {
      console.error("error in createStage:", error);
      Toast("error", error?.response?.data || "Failed to create call stage");
    }
  };

  const updateStage = async () => {
    const isSystemStage = editingStage?.is_system;
    const name = stageFormik.values.name?.trim();
    const category = stageFormik.values.isActiveCategory
      ? "active"
      : "terminal";

    if (!stageFormik.values.id || (!isSystemStage && !name)) {
      Toast("error", "Please fill all the required fields!");
      return;
    }

    const payload = isSystemStage
      ? {
          id: stageFormik.values.id,
          is_active: stageFormik.values.is_active,
        }
      : {
          id: stageFormik.values.id,
          name,
          category,
          is_active: stageFormik.values.is_active,
        };

    try {
      const response = await post(
        VYLABS_BASE_URL,
        TENANTS_UPDATE_APPLICATION_STAGE,
        payload,
        { headers: { "X-API-Key": TENANT_CORE_API_KEY } },
      );
      if (response) {
        invalidateCallStagesCache();
        Toast("success", "Call Stage updated successfully");
        setIsUpdateStagePopupOpen(false);
        setEditingStage(null);
        stageFormik.resetForm();
        fetchStages(isActiveStageFilter, setStages);
        refreshPreviewStages();
      }
    } catch (error) {
      console.error("error in updateStage:", error);
      Toast("error", error?.response?.data || "Failed to update call stage");
    }
  };

  const handleEditStage = (stage) => {
    setEditingStage(stage);
    stageFormik.setValues({
      id: stage?.id || "",
      name: stage?.name || "",
      category: stage?.category || "active",
      is_active: stage?.is_active ?? true,
      isActiveCategory: stage?.category !== "terminal",
    });
    setIsUpdateStagePopupOpen(true);
  };

  const handleDeleteStage = async () => {
    if (!deleteStageId) return;

    try {
      const response = await post(
        VYLABS_BASE_URL,
        TENANTS_UPDATE_APPLICATION_STAGE,
        {
          id: deleteStageId,
          is_active: deleteStageActive,
        },
        { headers: { "X-API-Key": TENANT_CORE_API_KEY } },
      );

      if (response) {
        invalidateCallStagesCache();
        Toast(
          "success",
          `Call Stage marked as ${deleteStageActive ? "active" : "inactive"} successfully`,
        );
        setIsDeleteStageOpen(false);
        setDeleteStageId(null);
        setDeleteStageActive(true);
        fetchStages(isActiveStageFilter, setStages);
        refreshPreviewStages();
      }
    } catch (error) {
      console.error("error in deleteStage:", error);
      Toast(
        "error",
        error?.response?.data || "Failed to update call stage status",
      );
    }
  };

  const reorderStages = async (stageList = stages, isPreview = false) => {
    const stageIds = stageList
      .map((stage) => stage.id)
      .filter(Boolean);

    if (!stageIds.length) {
      if (!isPreview) setIsReorderStagesOn(false);
      return;
    }

    try {
      const response = await post(
        VYLABS_BASE_URL,
        TENANTS_REORDER_APPLICATION_STAGES,
        { stage_ids: stageIds },
        { headers: { "X-API-Key": TENANT_PRIME_API_KEY } },
      );

      if (response) {
        invalidateCallStagesCache();
        Toast("success", "Call Stages reordered successfully");
        if (!isPreview) {
          setIsReorderStagesOn(false);
          fetchStages(isActiveStageFilter, setStages);
        } else {
          refreshPreviewStages();
        }
      }
    } catch (error) {
      console.error("error in reorderStages:", error);
      Toast("error", error?.response?.data || "Failed to reorder call stages");
      if (!isPreview) {
        fetchStages(isActiveStageFilter, setStages);
      } else {
        refreshPreviewStages();
      }
    }
  };

  const handleStageDragEnd = (event, setStageList = setStages) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setStageList((prevStages) => {
      const oldIndex = prevStages.findIndex((stage) => stage.id === active.id);
      const newIndex = prevStages.findIndex((stage) => stage.id === over.id);

      if (oldIndex < 0 || newIndex < 0) return prevStages;

      return arrayMove(prevStages, oldIndex, newIndex);
    });
  };

  const handleCloseStagePopup = () => {
    setIsUpdateStagePopupOpen(false);
    setEditingStage(null);
    stageFormik.resetForm();
  };

  const stageColumns = [
    {
      name: "STAGE NAME",
      selector: (row) => row?.name || "-",
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div
          style={{ display: "flex", flexDirection: "column", padding: "8px 0" }}
        >
          <span>{toCapitalize(row?.name) || "-"}</span>
        </div>
      ),
    },
    {
      name: "TYPE",
      selector: (row) => row?.is_system,
      cell: (row) => (
        <span className={row?.is_system ? "cf-system-pill" : "cf-custom-pill"}>
          {row?.is_system ? "System" : "Custom"}
        </span>
      ),
    },
    {
      name: "STATUS",
      selector: (row) => row?.is_active,
      cell: (row) => (
        <span
          style={{
            display: "inline-flex",
            padding: "4px 10px",
            borderRadius: "999px",
            border: row?.is_active
              ? "1px solid rgba(34, 197, 94, 0.2)"
              : "1px solid rgba(101, 123, 167, 0.2)",
            backgroundColor: row?.is_active
              ? "rgba(34, 197, 94, 0.12)"
              : "rgba(101, 123, 167, 0.12)",
            color: row?.is_active ? "#16A34A" : "rgb(101, 123, 167)",
            fontWeight: 500,
          }}
        >
          {row?.is_active ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      name: "ACTIONS",
      cell: (row) => (
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "80px",
            }}
          >
            {isPrimaryCallStage(row) ? (
              <CustomTooltip
                title="This is a primary system field which cannot be edited."
                arrow
              >
                <img
                  src={crownIcon}
                  alt="Primary system stage"
                  style={{ width: "18px", height: "18px", cursor: "default" }}
                />
              </CustomTooltip>
            ) : (
              <>
                {!row?.is_system && (
                  <img
                    src={isDarkMode ? editIcon : editLightIcon}
                    alt="Edit"
                    style={{ cursor: "pointer", opacity: 0.7 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditStage(row);
                    }}
                  />
                )}
                <ToggleSwitcher
                  name={`delete_stage_${row.id}`}
                  value={row?.is_active}
                  onChange={(name, value) => {
                    setDeleteStageId(row.id);
                    setDeleteStageActive(value);
                    setIsDeleteStageOpen(true);
                  }}
                />
              </>
            )}
          </div>
        ),
      width: "110px",
      center: true,
      ignoreRowClick: true,
    },
  ];

  const SortableStage = ({ stage, children, disabled = false }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: stage.id, disabled });
    return (
      <div
        ref={setNodeRef}
        style={{ transform: CSS.Transform.toString(transform), transition }}
        className={isDragging ? "cf-dragging" : ""}
        {...attributes}
      >
        {children({ listeners, isDragging })}
      </div>
    );
  };

  const fetchFields = async () => {
    setLoading(true);
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${TENANT_FIELD_DEFINITIONS_LIST}?entity_type=${activeTab === 0 ? "candidate" : "job"}`,
        {
          headers: {
            "X-API-Key": TENANT_CORE_API_KEY,
          },
        },
      );
      setFields(response?.definitions ? response.definitions : []);
    } catch (error) {
      console.error("error in fetchFields:", error);
      Toast("error", "Failed to fetch custom fields");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 2 && !isCreateFieldPopupOpen) {
      setStageCurrentPage(1);
      fetchStages(isActiveStageFilter, setStages);
    } else {
      fetchFields();
    }
  }, [activeTab, isActiveStageFilter, isCreateFieldPopupOpen]);

  useEffect(() => {
    if (activeTab !== 2 || !isCreateFieldPopupOpen) return;

    const loadPreviewStages = async () => {
      const activeOnly =
        callStageFilter === "Active"
          ? true
          : callStageFilter === "Inactive"
            ? false
            : "all";

      const stageData = await fetchStages(activeOnly, setPreviewStages);

      if (!stageData) return;

      if (callStageFilter === "System") {
        setPreviewStages(stageData.filter((stage) => stage?.is_system));
      } else if (callStageFilter === "Custom") {
        setPreviewStages(stageData.filter((stage) => !stage?.is_system));
      } else {
        setPreviewStages(stageData);
      }
    };

    loadPreviewStages();
  }, [
    activeTab,
    isCreateFieldPopupOpen,
    callStageFilter,
  ]);

  useEffect(() => {
    if (activeTab !== 1) {
      setIsFilterValue({
        jobId: "",
        jobTitle: "",
        search: "",
      });
      createFormik.setFieldValue("job_id", "");
    }
  }, [activeTab]);

  const createField = async () => {
    try {
      if (
        !createFormik.values.field_key?.trim() ||
        !createFormik.values.field_type ||
        !createFormik.values.label
      ) {
        Toast("error", "Please fill all the required fields!");
        return;
      }
      let options;
      if (createFormik.values.field_type === "select") {
        if (createFormik.values.options.length === 0) {
          Toast("error", "Please fill all the required fields!");
          return;
        } else {
          options = createFormik.values.options;
        }
      }
      const response = await post(
        VYLABS_BASE_URL,
        TENANT_FIELD_DEFINITIONS_CREATE,
        filterPayload({
          entity_type: activeTab === 0 ? "candidate" : "job",
          field_key: createFormik.values.field_key
            ?.trim()
            .toLowerCase()
            .replace(/\s+/g, "_"),
          field_type: createFormik.values.field_type,
          label: createFormik.values.label,
          required: createFormik.values.required,
          job_id: activeTab === 1 ? createFormik.values.job_id : undefined,
          options,
        }),
        {
          headers: {
            "X-API-Key": TENANT_PRIME_API_KEY,
          },
        },
      );
      if (response?.definition) {
        const selectedJobName =
          filterValue.jobTitle ||
          jobListOptions.find((job) => job.value === createFormik.values.job_id)
            ?.label;
        const toastMessage =
          activeTab === 1 && selectedJobName
            ? `Custom Field created successfully for ${selectedJobName}`
            : "Custom Field created successfully";

        Toast("success", toastMessage);
        fetchFields();
        createFormik.resetForm();
        setIsFilterValue({
          jobId: "",
          jobTitle: "",
          search: "",
        });
        setSelectedQuickAddKey(null);
      }
    } catch (error) {
      console.error("error in createField:", error);
      Toast("error", error?.response?.data || "Failed to create custom field");
    }
  };

  const updateField = async () => {
    try {
      if (
        !editFormik.values.field_key?.trim() ||
        !editFormik.values.field_type
      ) {
        Toast("error", "Please fill all the required fields!");
        return;
      }

      let options;
      if (editFormik.values.field_type === "select") {
        if (editFormik.values.options.length === 0) {
          Toast("error", "Please fill all the required fields!");
          return;
        } else {
          options = editFormik.values.options;
        }
      }

      const payload = filterPayload({
        id: editFormik.values.id,
        entity_type: activeTab === 0 ? "candidate" : "job",
        field_key: editFormik.values.field_key
          ?.trim()
          .toLowerCase()
          .replace(/\s+/g, "_"),
        field_type: editFormik.values.field_type,
        label: editFormik.values.label,
        required: editFormik.values.required,
        options,
      });

      const response = await post(
        VYLABS_BASE_URL,
        TENANT_FIELD_DEFINITIONS_UPDATE,
        payload,
        {
          headers: {
            "X-API-Key": TENANT_PRIME_API_KEY,
          },
        },
      );

      if (response?.definition) {
        Toast("success", "Custom Field updated successfully");
        fetchFields();
        handleCloseEditPopup();
      }
    } catch (error) {
      console.error("error in updateField:", error);
      Toast("error", error?.response?.data || "Failed to update custom field");
    }
  };

  const handleSubmit = () => {
    if (isEditMode) {
      updateField();
    } else {
      createField();
    }
  };

  const handleEditField = (field) => {
    setEditingField(field);
    setIsEditMode(true);

    editFormik.setValues({
      entity_type: field.entity_type || "",
      field_key: field.field_key || "",
      field_type: field.field_type || "",
      label: field.label || "",
      required: field.required || false,
      options: field.options || [],
      id: field.id || "",
    });
    setIsUpdateFieldPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsCreateFieldPopupOpen(false);
    setIsEditMode(false);
    setEditingField(null);
    createFormik.resetForm();
    setIsFilterValue({
      jobId: "",
      jobTitle: "",
      search: "",
    });
    setSelectedQuickAddKey(null);
    fetchFields();
    setSystemCallStages([]);
    setCustomCallStages([]);
    setAllCallStages([]);
  };

  const handleCloseEditPopup = () => {
    setIsUpdateFieldPopupOpen(false);
    setIsEditMode(false);
    setEditingField(null);
    editFormik.resetForm();
  };

  const fetchJobsList = async () => {
    if (activeTab !== 1) return;
    if (jobListOptions.length > 0) return;

    setIsJobOptionLoading(true);

    try {
      const payload = {
        limit: JOBS_PAGE_SIZE,
        status: true,
        page: getJobsPageFromOffset(),
      };
      const response = await post(VYLABS_BASE_URL, JOBS_LIST, payload);
      const jobs = Array.isArray(response?.jobs) ? response.jobs : [];
      const options = jobs.filter((job) => job?.id).map((job) => ({
        label: job.title,
        value: job.id,
      }));
      setIsJobListOptions(options);
    } catch (error) {
      console.error("Fetch Jobs List", error);
    } finally {
      setIsJobOptionLoading(false);
    }
  };

  const handleJobInputChange = (_, value) => {
    if (activeTab !== 1) return;

    if (value && value.length >= 3) {
      fetchJobSearch(value);
    } else if (!value) {
      fetchJobsList();
    }
  };

  const fetchJobSearch = async (inputValue) => {
    if (activeTab !== 1 || !inputValue) return;

    setIsJobOptionLoading(true);
    try {
      const response = await post(VYLABS_BASE_URL, SEARC_JOBS, {
        query: inputValue,
      });

      const data = response.jobs || [];

      const fetchOptions = [
        ...new Map(
          data.map((item) => [
            item.id,
            {
              label: item.title,
              value: item.id,
            },
          ]),
        ).values(),
      ];
      setIsJobListOptions(fetchOptions);
    } catch (error) {
      console.error("Fetch Jobs Search", error);
    } finally {
      setIsJobOptionLoading(false);
    }
  };

  const handleDeleteField = async () => {
    const fieldId = deleteRowId;
    try {
      const response = await deleteRequest(
        VYLABS_BASE_URL,
        TENANT_FIELD_DEFINITIONS_DELETE,
        {
          id: fieldId,
        },
        {
          headers: {
            "X-API-Key": TENANT_PRIME_API_KEY,
          },
        },
      );
      if (response) {
        Toast("success", "Custom field deleted successfully");
        fetchFields();
        setIsDeleteOpen(false);
        setDeleteRowId(null);
      }
    } catch (error) {
      console.error("error in deleteField:", error);
      Toast("error", "Failed to delete custom field");
    }
  };

  const paginatedFields = fields.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );

  const paginatedStages = stages.slice(
    (stageCurrentPage - 1) * rowsPerPage,
    stageCurrentPage * rowsPerPage,
  );

  const columns = [
    {
      name: "FIELD NAME",
      selector: (row) => row.label || "-",
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "8px 0",
          }}
        >
          <span>{row.label || "-"}</span>
          {row.field_key && (
            <span
              style={{
                color: "var(--text-color-accent)",
                fontSize: "12px",
                marginTop: "2px",
              }}
            >
              {row.field_key}
            </span>
          )}
        </div>
      ),
    },
    {
      name: "FIELD TYPE",
      selector: (row) => row.field_type || "-",
      sortable: true,
      wrap: true,
      cell: (row) =>
        row.field_type === "select" ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "4px 10px",
              borderRadius: "999px",
              border: "1px solid var(--grid-bg)",
              backgroundColor: "var(--grid-bg)",
              color: "var(--text_color)",
            }}
          >
            <img
              src={isDarkMode ? dropdownDarkIcon : dropdownIcon}
              alt=""
              style={{ width: "14px", height: "14px" }}
            />
            Dropdown
          </span>
        ) : (
          <span
            style={{
              textTransform: "capitalize",
              color: "var(--text-color-accent)",
            }}
          >
            {row.field_type || "-"}
          </span>
        ),
    },
    {
      name: "REQUIRED",
      selector: (row) => row.required,
      sortable: true,
      cell: (row) =>
        row.required ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 10px",
              borderRadius: "999px",
              border: "1px solid rgba(239, 68, 68, 0.145)",
              backgroundColor: "rgba(239, 68, 68, 0.145)",
              color: "#E7000B",
              fontWeight: 500,
            }}
          >
            Required
          </span>
        ) : (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 10px",
              borderRadius: "999px",
              border: "1px solid rgba(101, 123, 167, 0.145)",
              backgroundColor: "rgba(101, 123, 167, 0.145)",
              color: "rgb(101, 123, 167)",
              fontWeight: 500,
            }}
          >
            Optional
          </span>
        ),
    },
    {
      name: "ACTIONS",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "80px",
          }}
        >
          <img
            src={isDarkMode ? editIcon : editLightIcon}
            alt="Edit"
            style={{
              cursor: "pointer",
              opacity: 0.7,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = 1)}
            onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
            onClick={(e) => {
              e.stopPropagation();
              handleEditField(row);
              setIsTableEditClicked(true);
            }}
          />
          <img
            src={isDarkMode ? deleteIcon : deleteLightIcon}
            alt="Delete"
            style={{
              cursor: "pointer",
              opacity: 0.7,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = 1)}
            onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
            onClick={(e) => {
              e.stopPropagation();
              setDeleteRowId(row.id);
              setIsDeleteOpen(true);
            }}
          />
        </div>
      ),
      width: "100px",
      center: "true",
      ignoreRowClick: true,
    },
  ];

  const tenantFieldDefinitionsReorder = async () => {
    try {
      const reorderedCfIds = fields.map((field) => field.id);
      const res = await post(
        VYLABS_BASE_URL,
        TENANT_FIELD_DEFINITIONS_REORDER,
        {
          definition_ids: reorderedCfIds,
          entity_type: activeTab === 0 ? "candidate" : "job",
        },
        {
          headers: {
            "X-API-Key": TENANT_PRIME_API_KEY,
          },
        },
      );
      if (res?.definitions) {
        setFields(res.definitions);
        Toast("success", "Custom Field Reordered Successfully!");
      }
    } catch (e) {
      console.error("error in tenantFieldDefinitionsReorder", e);
      Toast("error", "Failed to Reorder Custom Fields.");
      fetchFields();
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setFields((prevFields) => {
      const oldIndex = prevFields.findIndex((field) => field.id === active.id);

      const newIndex = prevFields.findIndex((field) => field.id === over.id);

      return arrayMove(prevFields, oldIndex, newIndex);
    });
  };

  const SortableField = ({ field, children }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: field.id,
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <div
        ref={setNodeRef}
        style={style}
        className={`
          ${isDragging ? "cf-dragging" : ""}
        `}
        {...attributes}
      >
        {children({ listeners, isDragging })}
      </div>
    );
  };

  const StageCategoryToggle = ({ value, onChange }) => (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "3px",
        gap: "2px",
        border: "1px solid var(--border__color)",
        borderRadius: "999px",
        background: "var(--body__background)",
      }}
    >
      <Button
        label="Active"
        event={() => onChange(true)}
        style={{
          border: "none",
          borderRadius: "999px",
          padding: "6px 12px",
          fontSize: "12px",
          fontWeight: value ? 600 : 500,
          cursor: "pointer",
          background: value ? "#6860EE" : "transparent",
          color: value ? "#fff" : "var(--grid-na-text)",
          minWidth: "65px",
          transition: "all 0.2s ease",
        }}
        hoverd={false}
      />
      <Button
        label="Inactive"
        event={() => onChange(false)}
        style={{
          border: "none",
          borderRadius: "999px",
          padding: "6px 12px",
          fontSize: "12px",
          fontWeight: !value ? 600 : 500,
          cursor: "pointer",
          background: !value ? "#6860EE" : "transparent",
          color: !value ? "#fff" : "var(--grid-na-text)",
          minWidth: "65px",
          transition: "all 0.2s ease",
        }}
        hoverd={false}
      />
    </div>
  );

  const getCallStageFilterCount = (filter) => {
    switch (filter) {
      case "Active":
        return allCallStages.filter((stage) => stage?.is_active).length;
      case "Inactive":
        return allCallStages.filter((stage) => !stage?.is_active).length;
      case "System":
        return allCallStages.filter((stage) => stage?.is_system).length;
      case "Custom":
        return allCallStages.filter((stage) => !stage?.is_system).length;
      case "All Stages":
      default:
        return allCallStages.length;
    }
  };

  const handleCallStageFilterChange = (filter) => {
    setCallStageFilter(filter);
  };

  const isPrimaryCallStage = (stage) =>
  {
    console.log("stage",stage);
    console.log("stage?.is_required",stage?.is_required);
    return stage?.is_required;
  }

  const renderCallStageBuilder = () => (
    <div className="cf-create-sidepopup-container">
      <div className="cf-left-column">
        <div className="cf-create-left-side">
          <div
            style={{
              display: "grid",
              gap: "10px",
            }}
          >
            <div className="add-new-field-card">
              <div className="add-new-field-icon">+</div>

              <div className="add-new-field-content">
                <div className="add-new-field-title">Add a new call stage</div>

                <div className="add-new-field-subtitle">
                  It will be added to the candidate call stage workflow.
                </div>
              </div>
            </div>

            <DynamicTextField
              label="Stage Name"
              name="name"
              placeholder="E.g., Phone Screen"
              value={stageFormik.values.name}
              onChange={stageFormik.handleChange}
              labelStyle={{
                marginBottom: "10px",
                fontWeight: "400",
              }}
              required
            />
          </div>

          <Button
            label="+ Add to form"
            event={createStage}
            width="100%"
            style={{ marginTop: "10px" }}
            hoverd={false}
          />
        </div>
      </div>

      <div className="cf-preview-container">
        <div>
          <span>Tip: </span>
          <span className="cf-tip-content">
            Drag and drop custom call stages to arrange the order recruiters
            should see them.
          </span>
        </div>

        <div className="cf-preview-card">
          <div className="cf-preview-header">
            <span className="cf-preview-label">PREVIEW</span>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h3>Call Stages</h3>
                <p>
                  System and custom stages can be activated, deactivated, and reordered.
                </p>
              </div>
            </div>
          </div>

          <div className="cf-preview-divider" />
          <div style={{display: "flex", margin: "10px"}}>
            <MonthFilter
              value={callStageFilter}
              options={callStageFilters.map((filter) => ({
                label: `${filter.title} (${getCallStageFilterCount(filter.title)})`,
                value: filter.title,
              }))}
              onChange={handleCallStageFilterChange}
              ariaLabel="Call stage filter"
            />
          </div>
          <div className="cfcallstage-outer-preview-fields">
            {previewStages.length === 0 ? (
              <div className="no-custom-fields-found">
                <h3>{`There are no ${callStageFilter} stages found.`}</h3>
                <AnimationPlayer
                  animationSrc={NojobsAnimation}
                  playerHeight="260px"
                  playerWidth="260px"
                />
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                    marginLeft: "10px",
                  }}
                >
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    className="drag-drop-info-icon"
                  />
                  <span style={{ color: "var(--text-color-accent)" }}>
                    Switch to Active to reorder system and custom stages.
                  </span>
                </div>

                <div className="cfcallstage-preview-fields">
                  <DndContext
                    collisionDetection={closestCenter}
                    onDragEnd={(event) =>
                      handleStageDragEnd(event, setPreviewStages)
                    }
                  >
                    <SortableContext
                      items={previewStages.map((stage) => stage.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {previewStages.map((stage) => (
                          <SortableStage
                            key={stage.id}
                            stage={stage}
                            disabled={!stage?.is_active}
                          >
                            {({ listeners, isDragging }) => (
                              <div
                                className={`cf-system-field-card ${
                                  !stage?.is_system ? "cf-custom-field-card" : ""
                                }`}
                              >
                                {callStageFilter === "Active" && (
                                  <div
                                    {...(stage?.is_active ? listeners : {})}
                                    style={{
                                      color: "var(--text_color)",
                                      cursor: stage?.is_active
                                        ? isDragging
                                          ? "grabbing"
                                          : "grab"
                                        : "default",
                                      minWidth: "24px",
                                      opacity: stage?.is_active ? 1 : 0.45,
                                    }}
                                  >
                                    ⋮⋮
                                  </div>
                                )}

                                <div className="cf-system-field-content">
                                  <div className="cf-system-field-header">
                                    <span
                                      className="cf-system-title"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "7px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "8px",
                                          height: "8px",
                                          minWidth: "8px",
                                          borderRadius: "50%",
                                          backgroundColor: stage?.is_active
                                            ? "#22C55E"
                                            : "#FFFFFF",
                                          border: stage?.is_active
                                            ? "1px solid #22C55E"
                                            : "1px solid #D1D5DB",
                                          display: "inline-block",
                                        }}
                                      />
                                      {toCapitalize(stage.name) || "-"}
                                    </span>

                                    <span
                                      className={
                                        stage?.is_system
                                          ? "cf-system-pill"
                                          : "cf-custom-pill"
                                      }
                                    >
                                      {stage?.is_system ? (
                                        <>
                                          <img
                                            src={cfSystemLock}
                                            alt=""
                                            className="cf-system-lock"
                                          />
                                          System
                                        </>
                                      ) : (
                                        "Custom"
                                      )}
                                    </span>
                                  </div>
                                </div>

                                <div className="cf-preview-actions">
                                  {isPrimaryCallStage(stage) ? (
                                    <CustomTooltip
                                      title="This is a primary system field which cannot be edited."
                                      arrow
                                    >
                                      <img
                                        src={crownIcon}
                                        alt="Primary system stage"
                                        className="cf-preview-action-icon"
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                          cursor: "default",
                                        }}
                                      />
                                    </CustomTooltip>
                                  ) : (
                                    <>
                                      {!stage?.is_system && (
                                        <img
                                          src={
                                            isDarkMode
                                              ? editIcon
                                              : editLightIcon
                                          }
                                          alt="Edit"
                                          className="cf-preview-action-icon"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleEditStage(stage);
                                          }}
                                        />
                                      )}
                                      {isActiveStageCategory && (
                                        <ToggleSwitcher
                                          name={`delete_stage_${stage.id}`}
                                          value={stage?.is_active}
                                          onChange={(name, value) => {
                                            setDeleteStageId(stage.id);
                                            setDeleteStageActive(value);
                                            setIsDeleteStageOpen(true);
                                          }}
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </SortableStage>
                        ))}
                      </div>
                    </SortableContext>
                  </DndContext>
                </div>

                {previewStages.length >= 2 &&
                  callStageFilter === "Active" && (
                    <div>
                      <div className="cf-preview-divider" />

                      <div className="cf-preview-header">
                        <div>
                          <div className="cf-reorder-save-and-cancel">
                            <Button
                              iconSrc={saveIcon}
                              iconWidth="18px"
                              label="Save Rearranged Stages"
                              event={() => reorderStages(previewStages, true)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="calendar-integration">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "4px",
            }}
          >
            <h2 style={{ margin: 0 }}>
              {activeTab === 2 ? "Call Stages" : "Custom Fields"}
            </h2>
            {(activeTab === 2 ? stages.length : fields.length) > 0 && (
              <span className="custom-field-count-pill">
                {activeTab === 2 ? stages.length : fields.length}{" "}
                {activeTab === 2
                  ? stages.length === 1
                    ? "Stage"
                    : "Stages"
                  : fields.length === 1
                    ? "Field"
                    : "Fields"}
              </span>
            )}
          </div>
          <p
            style={{
              margin: 0,
              color: "var(--grid-na-text)",
              fontSize: "14px",
            }}
          >
            {activeTab === 2
              ? "Manage the system and custom stages used throughout candidate calls."
              : "Add extra information to Candidate form without changing the system."}
          </p>
        </div>
        <Button
          label={activeTab === 2 ? "Edit Call Stages" : "New Custom Field"}
          event={() => {
            if (activeTab === 2) {
              stageFormik.resetForm();
              setEditingStage(null);
              setIsActiveStageCategory(true);
              setCallStageFilter("All Stages");
            } else {
              setIsEditMode(false);
              setEditingField(null);
              createFormik.resetForm();
              setSelectedQuickAddKey(null);
            }
            stageFormik.resetForm();
            setIsActiveStageCategory(true);
            setIsCreateFieldPopupOpen(true);
            setIsTableEditClicked(false);
          }}
          style={{
            padding: "8px 16px",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
          iconSrc={addIcon}
          iconWidth="12px"
        />
      </div>
      <HorizontalTabs
        activeTab={activeTab}
        handleTabChange={setActiveTab}
        tabNames={[
          { name: "Candidate Form" },
          { name: "Job Form" },
          { name: "Call Stages" },
        ]}
        tabstyle={{ borderRadius: "10px 10px 0 0", marginBottom: "10px" }}
      />
      {activeTab === 2 ? (
        stageLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              flexDirection: "column",
            }}
          >
            <VybogTALLoaderAnimation />
          </div>
        ) : stages.length === 0 ? (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "12px",
              }}
            >
              <StageCategoryToggle
                value={isActiveStageFilter}
                onChange={setIsActiveStageFilter}
              />
            </div>
          <div className="no-custom-fields-found">
            <h3>{`No ${isActiveStageFilter ? "active" : "inactive"} call stages found.`}</h3>
            <AnimationPlayer
              animationSrc={NojobsAnimation}
              playerHeight="260px"
              playerWidth="260px"
            />
          </div>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "12px",
              }}
            >
              <StageCategoryToggle
                value={isActiveStageFilter}
                onChange={setIsActiveStageFilter}
              />
            </div>
            <Table
              columns={stageColumns}
              data={paginatedStages}
              pagination
              highlightOnHover
              fixedHeader
              fixedHeaderScrollHeight="600px"
              dataNotFoundMessage="No call stages found"
              clearSelectedRows={false}
              backgroundColor="var(--body__background)"
              color="var(--header__color)"
              paginationTotalRows={stages.length}
              paginationServer
              currentPage={stageCurrentPage}
              onChangePage={setStageCurrentPage}
            />
          </div>
        )
      ) : loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            flexDirection: "column",
          }}
        >
          <VybogTALLoaderAnimation />
        </div>
      ) : fields.length === 0 ? (
        <div className="no-custom-fields-found">
          <h3>No custom fields found. Please create a custom field first.</h3>
          <AnimationPlayer
            animationSrc={NojobsAnimation}
            playerHeight="260px"
            playerWidth="260px"
          />
        </div>
      ) : (
        <Table
          columns={columns}
          data={paginatedFields}
          pagination
          highlightOnHover
          fixedHeader
          fixedHeaderScrollHeight="600px"
          dataNotFoundMessage="No custom fields found"
          clearSelectedRows={false}
          backgroundColor="var(--body__background)"
          color="var(--header__color)"
          paginationTotalRows={fields.length}
          paginationServer
          currentPage={currentPage}
          onChangePage={setCurrentPage}
        />
      )}

      {!isTableEditClicked &&
        createPortal(
          <SidePopup
            isOpen={isCreateFieldPopupOpen}
            onClose={handleClosePopup}
            title="Form Builder"
            subTitle="Add fields or call stages on the left, then arrange them on the right."
            width="40%"
            children={
              <div>
                {activeTab === 2 && renderCallStageBuilder()}
                <div
                  className="cf-create-sidepopup-container"
                  style={{ display: activeTab === 2 ? "none" : undefined }}
                >
                  <div className="cf-left-column">
                    <div className="cf-create-left-side">
                      <div
                        style={{
                          display: "grid",
                          gap: "10px",
                        }}
                      >
                        <div className="add-new-field-card">
                          <div className="add-new-field-icon">+</div>

                          <div className="add-new-field-content">
                            <div className="add-new-field-title">
                              Add a new field
                            </div>

                            <div className="add-new-field-subtitle">
                              It will be added to the portal apply job form.
                            </div>
                          </div>
                        </div>
                        <DynamicTextField
                          label="Field Key"
                          name="field_key"
                          placeholder="E.g, Previous Salary"
                          value={createFormik.values.field_key}
                          onChange={createFormik.handleChange}
                          labelStyle={{
                            marginBottom: "10px",
                            fontWeight: "400",
                          }}
                          required
                        />
                        <DynamicSelectInput
                          label="Field Type"
                          labelStyle={{ marginBottom: "10px" }}
                          name="field_type"
                          options={fieldTypes}
                          value={createFormik.values.field_type}
                          onChange={(e) => {
                            const value = e.target.value;
                            createFormik.setFieldValue("field_type", value);
                            if (value !== "select") {
                              createFormik.setFieldValue("options", []);
                            }
                          }}
                          selectStyle={{ marginBottom: "15px" }}
                          required
                        />
                        {createFormik.values.field_type === "select" && (
                          <div>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <span style={{ marginBottom: "10px" }}>
                                Options
                                <span className="required-asterisk">*</span>
                              </span>
                            </label>
                            <CustomAutocomplete
                              multiple
                              placeholder="Enter options"
                              options={[]}
                              tags={true}
                              name="options"
                              value={createFormik.values.options}
                              onChange={(selectedOptions) => {
                                const validTags = selectedOptions
                                  .map((option) =>
                                    typeof option === "string"
                                      ? option
                                      : option.title,
                                  )
                                  .filter((option) => option.trim() !== "");

                                const uniqueTags = validTags.filter(
                                  (tag, index, self) =>
                                    index ===
                                    self.findIndex(
                                      (t) =>
                                        t.toLowerCase() === tag.toLowerCase(),
                                    ),
                                );

                                createFormik.setFieldValue(
                                  "options",
                                  uniqueTags,
                                );
                              }}
                              InputWrapperStyle={{
                                width: "auto",
                                height: "100px",
                                color: "var(--header__color) !important",
                                overflowY: "auto",
                                padding: "10px",
                                marginBottom: "10px",
                              }}
                              showClearAll={true}
                            />
                          </div>
                        )}
                        <DynamicTextField
                          label="Label"
                          labelStyle={{
                            marginBottom: "10px",
                            fontWeight: "400",
                          }}
                          name="label"
                          placeholder="E.g., Previous Salary"
                          value={createFormik.values.label}
                          onChange={createFormik.handleChange}
                          required
                        />
                        {activeTab === 1 && (
                          <div>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "10px",
                                color: "var(--text_color)",
                                fontWeight: "400",
                              }}
                            >
                              Select Job
                              <CustomTooltip
                                title={
                                  "Candidates will only see this custom field when applying to the selected job."
                                }
                                arrow
                              >
                                <img
                                  alt="infoIcon"
                                  src={infoIcon}
                                  style={{ width: "18px" }}
                                />
                              </CustomTooltip>
                            </label>
                            <DynamicAutocomplete
                              placeholder="Search Jobs..."
                              minCharsForSearch={0}
                              options={jobListOptions}
                              loading={jobOptionLoading}
                              value={
                                filterValue.jobId
                                  ? {
                                    label: filterValue.jobTitle,
                                    value: filterValue.jobId,
                                  }
                                  : null
                              }
                              onOpen={fetchJobsList}
                              onInputChange={handleJobInputChange}
                              onChange={(value) => {
                                const newFilters = {
                                  ...filterValue,
                                  jobTitle: value?.label || "",
                                  jobId: value?.value || "",
                                };
                                setIsFilterValue(newFilters);
                                createFormik.setFieldValue(
                                  "job_id",
                                  value?.value || "",
                                );
                              }}
                              sx={{
                                width: "100%",
                                ".MuiOutlinedInput-root": {
                                  borderRadius: "999px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border:
                                      "1px solid var(--border__color) !important",
                                    minHeight: "auto",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#6860ee",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#7a70f2",
                                  },
                                },
                                ".MuiInputBase-input": {
                                  color: "var(--header__color)",
                                  padding: "8px 12px !important",
                                  height: "40px",
                                  fontFamily: "Satoshi !important",
                                },
                              }}
                              slotProps={{
                                paper: {
                                  sx: {
                                    backgroundColor: "var(--body__background)",
                                    color: "var(--header__color)",
                                    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                                    border: "1px solid var(--header__color)",
                                  },
                                },
                                listbox: {
                                  sx: {
                                    "& li": {
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      padding: "8px 16px",
                                      color: "var(--header__color)",
                                      "&:hover": {
                                        backgroundColor: "rgba(0,0,0,0.04)",
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="required-field-card">
                        <div className="required-field-content">
                          <h4>Required</h4>
                          <p>Make this field mandatory</p>
                        </div>

                        <ToggleSwitcher
                          name="required"
                          value={createFormik.values.required}
                          onChange={createFormik.setFieldValue}
                        />
                      </div>
                      <div style={{ marginBottom: "20px" }}>
                        <div className="cf-quick-add-title">
                          <img src={quickAddIcon} alt="" />
                          <span>Quick add</span>
                        </div>

                        <div className="cf-quick-add-list">
                          {cfQuickAddFields.map((field) => {
                            const isSelected =
                              selectedQuickAddKey === field.field_key;
                            return (
                              <Button
                                key={field.field_key}
                                label={`+ ${field.label}`}
                                event={() => {
                                  setSelectedQuickAddKey(field.field_key);
                                  createFormik.setValues({
                                    ...createFormik.values,
                                    entity_type: field.entity_type,
                                    field_key: field.field_key,
                                    field_type: field.field_type,
                                    label: field.label,
                                    required: field.required,
                                  });
                                }}
                                style={{
                                  background: isSelected
                                    ? "#6860EE0D"
                                    : "transparent",
                                  color: isSelected
                                    ? "var(--all-tracked-created-selected-text)"
                                    : "var(--text_color)",
                                  border: isSelected
                                    ? "1px solid #6860EE4D"
                                    : "1px solid var(--border__color)",
                                  borderRadius: "999px",
                                  padding: "6px 14px",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  width: "fit-content",
                                  minWidth: "unset",
                                  height: "34px",
                                  boxShadow: "none",
                                }}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <Button
                        label="+ Add to form"
                        event={createField}
                        width="100%"
                        style={{ marginTop: "10px" }}
                        hoverd={false}
                      />
                    </div>
                  </div>
                  <div className="cf-preview-container">
                    <div>
                      <span>Tip: </span>
                      <span className="cf-tip-content">
                        Drag and drop custom fields to arrange the form in the
                        order recruiters should see them.
                      </span>
                    </div>
                    <div className="cf-preview-card">
                      <div className="cf-preview-header">
                        <span className="cf-preview-label">PREVIEW</span>
                        {activeTab === 0 ? (
                          <div>
                            <h3>Create Candidate</h3>
                            <p>This is exactly what recruiters will see.</p>
                          </div>
                        ) : (
                          <div>
                            <h3>Apply Job</h3>
                            <p>This is exactly what candidates will see.</p>
                          </div>
                        )}
                      </div>
                      <div className="cf-preview-divider" />
                      {activeTab === 0 ? (
                        <div className="cf-preview-fields">
                          <Accordion
                            title="System Fields"
                            titleColor="#6860EECC"
                            accordionHeaderStyle={{
                              border: "1px solid var(--border__color)",
                              borderRadius: "12px",
                            }}
                            accordionContentStyle={{
                              maxHeight: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                              }}
                            >
                              {candidateCreateFields.map((field) => (
                                <div
                                  className="cf-system-field-card"
                                  key={field.title}
                                >
                                  <div className="cf-system-field-content">
                                    <div className="cf-system-field-header">
                                      <span className="cf-system-title">
                                        {field.title}
                                        <span className="required-asterisk">
                                          *
                                        </span>
                                      </span>
                                      <span className="cf-system-pill">
                                        <img
                                          src={cfSystemLock}
                                          alt=""
                                          className="cf-system-lock"
                                        />
                                        System
                                      </span>
                                    </div>
                                    <input
                                      className="cf-system-input"
                                      placeholder={field.placeholder}
                                      disabled
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Accordion>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            <Accordion
                              title="Custom Fields"
                              titleColor="#6860EECC"
                              defaultOpen={true}
                              accordionHeaderStyle={{
                                border: "1px solid var(--border__color)",
                                borderRadius: "12px",
                              }}
                              accordionContentStyle={{
                                maxHeight: "100%",
                              }}
                            >
                              <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={handleDragEnd}
                              >
                                <SortableContext
                                  items={fields.map((field) => field.id)}
                                  strategy={verticalListSortingStrategy}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    {fields.map((field) => (
                                      <SortableField
                                        key={field.id}
                                        field={field}
                                      >
                                        {({ listeners, isDragging }) => (
                                          <div className="cf-system-field-card cf-custom-field-card">
                                            <div
                                              {...listeners}
                                              style={{
                                                color: "var(--text_color)",
                                                cursor: isDragging
                                                  ? "grabbing"
                                                  : "grab",
                                              }}
                                            >
                                              ⋮⋮
                                            </div>
                                            <div className="cf-system-field-content">
                                              <div className="cf-system-field-header">
                                                <span className="cf-system-title">
                                                  {field.label}
                                                  {field.required && (
                                                    <span className="required-asterisk">
                                                      *
                                                    </span>
                                                  )}
                                                </span>

                                                <span className="cf-custom-pill">
                                                  Custom
                                                </span>
                                              </div>

                                              <input
                                                className="cf-system-input"
                                                placeholder={field.label}
                                                disabled
                                              />
                                            </div>

                                            <div className="cf-preview-actions">
                                              <img
                                                src={
                                                  isDarkMode
                                                    ? editIcon
                                                    : editLightIcon
                                                }
                                                alt="Edit"
                                                className="cf-preview-action-icon"
                                                onClick={() => {
                                                  handleEditField(field);
                                                  setIsTableEditClicked(false);
                                                }}
                                              />

                                              <img
                                                src={cfPreviewDelete}
                                                alt="Delete"
                                                className="cf-preview-action-icon cf-preview-delete"
                                                onClick={() => {
                                                  setDeleteRowId(field.id);
                                                  setIsDeleteOpen(true);
                                                }}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </SortableField>
                                    ))}
                                  </div>
                                </SortableContext>
                              </DndContext>
                            </Accordion>
                          </div>
                        </div>
                      ) : (
                        <div className="cf-preview-fields">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            <FileUploadContainer>
                              <FileInputWrapper>
                                <FileInputLabel>
                                  <div className="drag-drop-info-container">
                                    <div className="inner-drag-drop-container">
                                      <img
                                        src={dragAndDropIcon}
                                        alt="uploadIcon"
                                        className="drag-and-drop-icon"
                                      />
                                      Drag & Drop or Click to upload resume
                                    </div>
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        fontSize: "12px",
                                        color: "#666",
                                        textAlign: "center",
                                      }}
                                    >
                                      Supported formats: PDF, DOC, DOCX
                                    </div>
                                  </div>
                                </FileInputLabel>
                              </FileInputWrapper>
                            </FileUploadContainer>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            <DndContext
                              collisionDetection={closestCenter}
                              onDragEnd={handleDragEnd}
                            >
                              <SortableContext
                                items={fields.map((field) => field.id)}
                                strategy={verticalListSortingStrategy}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                  }}
                                >
                                  {fields.map((field) => (
                                    <SortableField key={field.id} field={field}>
                                      {({ listeners, isDragging }) => (
                                        <div className="cf-system-field-card cf-custom-field-card">
                                          <div
                                            {...listeners}
                                            style={{
                                              color: "var(--text_color)",
                                              cursor: isDragging
                                                ? "grabbing"
                                                : "grab",
                                            }}
                                          >
                                            ⋮⋮
                                          </div>
                                          <div className="cf-system-field-content">
                                            <div className="cf-system-field-header">
                                              <span className="cf-system-title">
                                                {field.label}
                                                {field.required && (
                                                  <span className="required-asterisk">
                                                    *
                                                  </span>
                                                )}
                                              </span>

                                              <span className="cf-custom-pill">
                                                Custom
                                              </span>
                                            </div>

                                            <input
                                              className="cf-system-input"
                                              placeholder={field.label}
                                              disabled
                                            />
                                          </div>

                                          <div className="cf-preview-actions">
                                            <img
                                              src={
                                                isDarkMode
                                                  ? editIcon
                                                  : editLightIcon
                                              }
                                              alt="Edit"
                                              className="cf-preview-action-icon"
                                              onClick={() => {
                                                handleEditField(field);
                                                setIsTableEditClicked(false);
                                              }}
                                            />

                                            <img
                                              src={cfPreviewDelete}
                                              alt="Delete"
                                              className="cf-preview-action-icon cf-preview-delete"
                                              onClick={() => {
                                                setDeleteRowId(field.id);
                                                setIsDeleteOpen(true);
                                              }}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </SortableField>
                                  ))}
                                </div>
                              </SortableContext>
                            </DndContext>
                          </div>
                        </div>
                      )}
                      {fields.length >= 2 && (
                        <div>
                          <div className="cf-preview-divider" />
                          <div className="cf-preview-header">
                            <div>
                              <div className="cf-reorder-save-and-cancel">
                                <Button
                                  iconSrc={saveIcon}
                                  iconWidth="18px"
                                  label="Save Rearranged fields"
                                  event={tenantFieldDefinitionsReorder}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            }
          />,
          document.body,
        )}
      {isEditMode &&
        createPortal(
          <StandardPopup
            isOpen={isUpdateFieldPopupOpen}
            onClose={handleCloseEditPopup}
            title="Edit Custom Field"
            subTitle="Please update the details of the custom field."
            width="40%"
            submitLabel="Update"
            children={
              <div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "10px",
                  }}
                >
                  <DynamicTextField
                    label="Field Key"
                    name="field_key"
                    placeholder="E.g, Previous Salary"
                    value={editFormik.values.field_key}
                    onChange={editFormik.handleChange}
                    labelStyle={{ marginBottom: "10px" }}
                    required
                  />
                  <DynamicSelectInput
                    label="Field Type"
                    labelStyle={{ marginBottom: "10px" }}
                    name="field_type"
                    options={fieldTypes}
                    value={editFormik.values.field_type}
                    onChange={(e) => {
                      const value = e.target.value;
                      editFormik.setFieldValue("field_type", value);
                      if (value !== "select") {
                        editFormik.setFieldValue("options", []);
                      }
                    }}
                    required
                  />
                  {editFormik.values.field_type === "select" && (
                    <div>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span style={{ marginBottom: "10px" }}>
                          Options<span className="required-asterisk">*</span>
                        </span>
                      </label>
                      <CustomAutocomplete
                        multiple
                        placeholder="Enter options"
                        options={[]}
                        tags={true}
                        name="options"
                        value={editFormik.values.options}
                        onChange={(selectedOptions) => {
                          const validTags = selectedOptions
                            .map((option) =>
                              typeof option === "string"
                                ? option
                                : option.title,
                            )
                            .filter((option) => option.trim() !== "");

                          const uniqueTags = validTags.filter(
                            (tag, index, self) =>
                              index ===
                              self.findIndex(
                                (t) => t.toLowerCase() === tag.toLowerCase(),
                              ),
                          );

                          editFormik.setFieldValue("options", uniqueTags);
                        }}
                        InputWrapperStyle={{
                          width: "auto",
                          height: "100px",
                          color: "var(--header__color) !important",
                          overflowY: "auto",
                          padding: "10px",
                          marginBottom: "10px",
                        }}
                        showClearAll={true}
                      />
                    </div>
                  )}
                  <DynamicTextField
                    label="Label"
                    labelStyle={{ marginBottom: "10px" }}
                    name="label"
                    placeholder="E.g., Previous Salary"
                    value={editFormik.values.label}
                    onChange={editFormik.handleChange}
                    required
                  />
                </div>
                <div className="required-field-card">
                  <div className="required-field-content">
                    <h4>Required</h4>
                    <p>Make this field mandatory</p>
                  </div>

                  <ToggleSwitcher
                    name="required"
                    value={editFormik.values.required}
                    onChange={editFormik.setFieldValue}
                  />
                </div>
              </div>
            }
            onSubmit={updateField}
          />,
          document.body,
        )}
      {createPortal(
        <StandardPopup
          isOpen={isUpdateStagePopupOpen}
          onClose={handleCloseStagePopup}
          title="Edit Call Stages"
          subTitle={
            editingStage?.is_system
              ? "Update the system call stage status."
              : "Update the custom call stage details."
          }
          width="40%"
          submitLabel="Update"
          children={
            <div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "12px",
                }}
              >
                {!editingStage?.is_system && (
                  <DynamicTextField
                    label="Stage Name"
                    name="name"
                    placeholder="E.g., Phone Screen"
                    value={stageFormik.values.name}
                    onChange={stageFormik.handleChange}
                    required
                  />
                )}
              </div>
            </div>
          }
          onSubmit={updateStage}
        />,
        document.body,
      )}

      {createPortal(
        <ConfirmationPopup
          isOpen={isDeleteStageOpen}
          onClose={() => {
            setIsDeleteStageOpen(false);
            setDeleteStageId(null);
            setDeleteStageActive(true);
          }}
          title={deleteStageActive ? "Active Call Stage" : "Inactive Call Stage"}
          subTitle={
            deleteStageActive
              ? "This call stage can be used."
              : "This call stage can no longer be used."
          }
          message={
            deleteStageActive
              ? "Are you sure you want to mark this call stage as active?"
              : "Are you sure you want to mark this call stage as inactive?"
          }
          confirmLabel="Yes"
          onConfirm={handleDeleteStage}
        />,
        document.body,
      )}

      {createPortal(
        <ConfirmationPopup
          isOpen={isDeleteOpen}
          onClose={() => {
            setIsDeleteOpen(false);
            setDeleteRowId(null);
          }}
          title="Delete Custom Field"
          subTitle="This custom field will be permanently deleted and cannot be recovered."
          message="Are you sure you want to delete the custom field?"
          confirmLabel="Delete"
          onConfirm={handleDeleteField}
        />,
        document.body,
      )}
    </div>
  );
};

export default CalendarIntegration;
